<template>
  <b-modal title="Relatórios Diários" v-model="show" size="xl">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE RELATÓRIOS DIÁRIOS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getDiarios" :fields="fields.diario">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="deletar(data.item)" v-b-tooltip.hover title="Deletar">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAIS DE USO :::::::::::::::::::::::::::: -->
    <diario-edit-modal ref="diarioEdit" @update="update()" />
    <confirm-modal ref="confirmDelDiario" :descricao="'Deseja realmente remover o relatório diário ?'" @executar="executar()" />

    <template #modal-footer>
      <b-button class="pl-2 pr-3" variant="info" @click="adicionar()">
        <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
      </b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { VMoney } from "v-money";
import { useEquipeStore } from "@/stores/EquipeStore";
import TableFields from "@/tools/TableFields";
import Equipe from "@/models/Equipe";
import Diario from "@/models/Diario";
import DiarioModal from "@/components/modals/equipe/DiarioModal";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";

export default {
  name: "DiarioListModal",

  components: {
    "diario-edit-modal": DiarioModal,
    "confirm-modal": ConfirmModal,
  },

  directives: { money: VMoney },

  data() {
    return {
      show: false,
      fields: new TableFields(),
      equipe: new Equipe(0, "", "Nova Equipe", new Date(), 0.0),
      diario: new Diario(0, new Date(), "", "", ""),
      diarios: [],
    };
  },

  methods: {
    editar(diario) {
      diario.equipe = this.equipe;
      this.$refs.diarioEdit.call(diario);
    },

    adicionar() {
      let diario = new Diario(0, new Date(), "", "", "");
      diario.equipe = this.equipe;
      this.$refs.diarioEdit.call(diario);
    },

    deletar(diario) {
      this.diario.update(diario);
      this.$refs.confirmDelDiario.call();
    },

    executar() {
      this.equipeStore.REMOVER_DIARIO(this.diario.id).then(() => {
        this.update();
      });
    },

    update() {
      this.equipeStore.LISTAR_DIARIOS(this.equipe.id).then(() => {
        this.diario = new Diario(0, new Date(), "", "", "");
        this.diarios = this.getDiarios;
      });
    },

    call(equipe) {
      this.show = !this.show;
      this.equipe = equipe;
      this.update();
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipeStore = useEquipeStore();
    const { getDiarios } = storeToRefs(equipeStore);

    return {
      store,
      equipeStore,
      getDiarios,
    };
  },
};
</script>

<style lang="scss" scoped></style>
